import ToastService from "./Toast.Service";
import Router, {useRouter} from "next/router";
class ClientServices {

    async getClients(jwtToken, page = 0, limit = 20) {

        return await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/clients?" + new URLSearchParams({
            pagination: true,
                limit: limit,
                page: page,
            }),
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        ).then((response) => response.json());
    }

}

export default new ClientServices();
